import { splitLink } from "lib/graphql/split-link"
import { errorLink } from "lib/graphql/error-link"

export const links = [errorLink, splitLink]
